
import { mapState, mapActions } from 'vuex'

import Icon from '../../../common/Icon'

export default {
  name: 'PayInStore',
  components: { Icon },
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      type: 'payinstore'
    }
  },
  computed: {
    ...mapState({
      paymentType: state => state.checkout.type,
      billing: state => state.checkout.billing
    }),
    enabled() {
      return !this.disabled && this.billing.find(b => b.type === this.type) ? true : false
    },
    selected() {
      return this.paymentType === this.type
    }
  },
  methods: {
    ...mapActions({
      setPaymentSelection: 'checkout/setPaymentSelection'
    })
  }
}
